import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Plane, 
  Phone, 
  Mail, 
  MapPin, 
  Clock,
  MessageCircle,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Youtube
} from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' }
  ];

  const services = [
    'Document Courier',
    'Parcel Courier',
    'Medicine Courier',
    'Food Items Courier',
    'Commercial Shipment',
    'Excess Baggage'
  ];

  const contactInfo = [
    {
      icon: <Phone size={18} strokeWidth={1.5} />,
      text: '+91 8847428801',
      link: 'tel:+918847428801'
    },
    {
      icon: <MessageCircle size={18} strokeWidth={1.5} />,
      text: 'WhatsApp: +91 8847428801',
      link: 'https://wa.me/918847428801'
    },
    {
      icon: <Mail size={18} strokeWidth={1.5} />,
      text: 'packnfly96@gmail.com',
      link: 'mailto:packnfly96@gmail.com'
    },
    {
      icon: <MapPin size={18} strokeWidth={1.5} />,
      text: 'Plot No 5A, Industrial Area, Phase 2, Panchkula, Haryana',
      link: 'https://www.google.com/maps/search/Plot+No+5A+Industrial+Area+Phase+2+Panchkula+Haryana'
    },
    {
      icon: <Clock size={18} strokeWidth={1.5} />,
      text: 'Mon-Sat: 9AM-7PM',
      link: null
    }
  ];

  const socialLinks = [
    { icon: <Facebook />, url: 'https://facebook.com', label: 'Facebook' },
    { icon: <Twitter />, url: 'https://twitter.com', label: 'Twitter' },
    { icon: <Instagram />, url: 'https://instagram.com', label: 'Instagram' },
    { icon: <Linkedin />, url: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: <Youtube />, url: 'https://youtube.com', label: 'YouTube' }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-section">
              <div className="footer-logo">
                <Plane className="logo-icon" />
                <span>Pack N Fly</span>
              </div>
              <p>
                Your trusted partner for international courier services from Chandigarh 
                to worldwide. We provide fast, safe, and affordable shipping for documents, 
                parcels, medicines, food items, and commercial shipments with free doorstep 
                pickup in Chandigarh, Mohali, Panchkula, and Zirakpur.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                {quickLinks.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="footer-section">
              <h3>Our Services</h3>
              <ul className="footer-links">
                {services.map((service, index) => (
                  <li key={index}>
                    <Link to="/services">{service}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h3>Contact Information</h3>
              <div className="contact-list">
                {contactInfo.map((contact, index) => (
                  <div key={index} className="contact-item">
                    <span className="contact-icon">
                      {contact.icon}
                    </span>
                    {contact.link ? (
                      <a href={contact.link} className="contact-link" target={contact.link.startsWith('https') ? '_blank' : undefined} rel={contact.link.startsWith('https') ? 'noopener noreferrer' : undefined}>
                        {contact.text}
                      </a>
                    ) : (
                      <span className="contact-text">{contact.text}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Pack N Fly. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
